// extracted by mini-css-extract-plugin
module.exports = {"message_input":"messageInput_message_input__2hl4r","send_btn":"messageInput_send_btn__1z4Ud"};